import React from 'react';

import {VideoIcon} from './svg';
import {cx} from '../util';

const VideoBadge = ({className}) => (
  <span className={cx(`
      hidden
      items-center
      whitespace-nowrap
      text-indigo
      bg-indigo-100
      rounded-full
      px-1.5
      py-0.5
      md:inline-flex
    `,
  className)}
  >
    <VideoIcon className="w-3.5 h-3.5" />
    <span className="sr-only">Has video answer</span>
  </span>
);

export default VideoBadge;
